// Format used for project internal purposes only. eg. query parameters and communication with BE
export const internalDateFormat: string = 'yyyy-MM-dd';
export const multiDownloadUrl: string = encodeURI('/api/downloadcenter/MultiDownload');
